import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ArticleService } from "../article/article.service";
import { Alert } from "../alert/alert";

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
  animations: [
    trigger('modalState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '1',
        display: 'flex'
      })),
      transition('hide => show, show => hide', animate('200ms ease-in'))
    ]),
    trigger('modalDialogState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '0.8',
        display: 'flex'
      })),
      transition('hide => show, show => hide', animate('200ms ease-in'))
    ])
  ]
})
export class ModalComponent implements OnInit {

  public alert = new Alert('hide', '', '');
  public imgTitle:string;
  public formData:FormData = new FormData();

  constructor(private articleService:ArticleService,
              public router:Router) {
  }

  ngOnInit() {
  }

  @Input() modalState:string;
  @Input() isbn:string;

  @Output() modalStateChange = new EventEmitter();
  @Output() alertChange = new EventEmitter();
  @Output() getArticle = new EventEmitter();

  public close():void {
    this.modalStateChange.emit('hide');
  }

  public fileUploaded(event, fieldname):void {
    // parse file from event obj
    let file = event.target.files[0];

    // attach file to formData obj
    this.formData.append(fieldname, file);
  }

  public updateArticleImg():void {
    // attach image title and isbn to formData obj
    this.formData.append('imgTitle', this.imgTitle);
    this.formData.append('isbn', this.isbn);

    // initiate request to bookshelf
    this.articleService.updateArticleImage(this.formData).subscribe(
      suc => {
        this.getArticle.emit(this.isbn);

        this.modalStateChange.emit('hide');

        this.alertChange.emit(new Alert('show', 'alert-success', 'Das Titelbild wurde erfolgreich aktualisiert'));
      },
      err => {
        if (err.status == 403) {
          this.router.navigate(['login']);
        } else {
          this.alert.update('show', 'alert-danger', err._body);
          setTimeout(() => this.alert.state = 'hide', 4000);
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/modal/modal.component.ts